import React, { type ReactNode } from 'react';
import { Platform, StyleSheet } from 'react-native';

import { Container, theme, useNavbarContainerHeight, useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { PageWrapper } from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardRedemptionContainer = (props: GiftCardRedemptionContainerProps) => {
  const { currentBreakpoint } = useResponsive();
  const { paddingBottomStyle: navbarPaddingBottomStyle } = useNavbarContainerHeight();
  const isNavbarV2Enabled = useFeatureFlag('CELS-5440-order-navbar-v2-enabled');

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldApplyNavbarPadding = isNavbarV2Enabled && currentBreakpoint.isXS;

  // ─── Styles ────────────────────────────────────────────────────────────────

  const safeAreaViewStyles = [
    nativeSafeAreaViewStyle,
    shouldApplyNavbarPadding ? navbarPaddingBottomStyle : undefined,
  ];

  return (
    <PageWrapper
      safeAreaEdges={isNavbarV2Enabled ? ['top'] : undefined}
      safeAreaViewStyle={safeAreaViewStyles}
      withoutFooter={currentBreakpoint.isXS}
    >
      <Container wrapperStyle={styles.outerContainer} style={styles.innerContainer}>
        {props.children}
      </Container>
    </PageWrapper>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flexGrow: 1,
  },
  innerContainer: {
    flexGrow: 1,
    alignItems: 'center',
    paddingTop: theme.spacing['8'],
    paddingBottom: theme.spacing['12'],
    minHeight: 300,
  },
  safeAreaView: {
    maxHeight: undefined, // overrides default style
  },
});

const nativeSafeAreaViewStyle = Platform.select({ native: styles.safeAreaView });

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardRedemptionContainerProps = {
  children: ReactNode;
};
